
<div >
  

    <div class="row">
        <div class="d-flex justify-content-end">
            <button (click)="crearCuentaAsesor()" class="btn " style="background-color: #597CEE; height: 38px;color: #FFFFFF; margin-top: -30px; "><i class="fas fa-plus"></i> Crear Cuenta</button>
        </div>
    </div>
    <div class="row" style="margin-top: 20px;">
      <div class="col-lg-1">
          <p class="title-descriptor">Filtrar Por:</p>
      </div>
      <div class="col-lg-2">
          <mat-form-field>
              
              <mat-label>Región</mat-label>
              <mat-select id="region" name="region" class="selectMedio"  (selectionChange)="seleccionarRegion($event.value)">
                  <mat-option [value]="0">Seleccione Región</mat-option>
                  <mat-option [value]="regiones.idRegion" *ngFor="let regiones of infoSelectJardin.regiones">{{regiones.nombre}}</mat-option>
              </mat-select>
          </mat-form-field>  
      </div>
      <div class="col-lg-2">

      </div>
        <div class="col-lg-2">
        
      </div>
      <div class="col-lg-5 d-flex justify-content-end" >
        <input class="form-control me-sm-2" type="text" (keyup.enter)="buscar(palabraClave)" [(ngModel)]="palabraClave" style="width: 300px; height: 45px;" placeholder="Buscar">
                <button class="btn btn-secondary" type="submit" (click)="buscar(palabraClave)" style="width: 130px;height: 45px;"><i class="fas fa-search"></i> Buscar</button>
      </div>
    </div>
  
    <div>
      <table class="tables-info" mat-table [dataSource]="dataSourceOtrasCuentas" matSort>
    
        <ng-container matColumnDef="region">
          <th mat-header-cell *matHeaderCellDef > Región </th>
          <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.region.nombre}} </td>
        </ng-container>
  
        <ng-container matColumnDef="nombres">
          <th mat-header-cell *matHeaderCellDef > Nombres</th>
          <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.nombre}} </td>
        </ng-container>
  
        <ng-container matColumnDef="apellidos">
          <th mat-header-cell *matHeaderCellDef > Apellidos</th>
          <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.apellidoPaterno + ' ' + row.apellidoMaterno}} </td>
        </ng-container>
  
        <ng-container matColumnDef="correo">
          <th mat-header-cell *matHeaderCellDef > Correo</th>
          <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.email}} </td>
        </ng-container>
  
        <ng-container matColumnDef="usuario">
          <th mat-header-cell *matHeaderCellDef > Usuario</th>
          <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.usuario}} </td>
        </ng-container>
  
        <ng-container matColumnDef="password">
          <th mat-header-cell *matHeaderCellDef > Contraseña</th>
          <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.contrasena}} </td>
        </ng-container>
  
        <ng-container matColumnDef="bloqueo">
          <th mat-header-cell *matHeaderCellDef > Bloqueado</th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox class="example-margin" [(ngModel)]="row.bloqueo" (change)="bloquear(row, 'us_persona')">
              <span class="material-icons closed" *ngIf="row.bloqueo">lock</span>
              <span class="material-icons open" *ngIf="!row.bloqueo">lock_open</span>                        
            </mat-checkbox>
          </td>
        </ng-container>
  
        <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef > Acciones</th>
            <td mat-cell *matCellDef="let row; let i = index"> 
                <button mat-mini-fab class="btn-eliminar" (click)="editarCuenta(row, i)">
                    <mat-icon>edit</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsOtrasCuentas"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsOtrasCuentas;">
        </tr>
      </table>
  
      <mat-paginator
              [length]="length"
              [pageIndex]="pageIndex"
              [pageSizeOptions]="[10, 50, 100]"
              [showFirstLastButtons]="true"
              (page)="getServerData($event)">
          </mat-paginator>
    </div>
  </div>
  
  <ng-template #modalFromAsesorTecnico let-modal>
    <div class="modal-header" style="padding: 0px 50px;" width="100%">
        <h5 id="modalTitleUser" class="titulo-card-amarillo" style="    margin: 25px">Asesor Técnico</h5>
        <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding: 0px 50px;" width="100%">
        <div class="row">
            <div class="row row-form mt-3">
                <div class="col-sm-6">
                    <label>Rut (Sin puntos con guión)</label>
                </div>
                <div class="col-sm-6">
                    <input type="text" class="form-control" id="rut" placeholder="11111111-1"  value="{{encargadoRecionalModel.rut}}" [(ngModel)]="encargadoRecionalModel.rut" [disabled]="editar" >
                    <div class="invalid" *ngIf="validacionRut" > Debe ingresar un Rut valido</div>
                </div>
            </div>
            <div class="row row-form">
                <div class="col-sm-6">
                    <label>Nombres</label>
                </div>
                <div class="col-sm-6">
                    <input type="text" class="form-control" id="nombres" placeholder="Nombres"  value="{{encargadoRecionalModel.nombre}}" [(ngModel)]="encargadoRecionalModel.nombre">
                    <div class="invalid" *ngIf="validacionNombres" > Debe ingresar un Nombre valido</div>
                </div>
            </div>
            <div class="row row-form">
                <div class="col-sm-6">
                    <label>Primer Apellido</label>
                </div>
                <div class="col-sm-6">
                    <input type="text" class="form-control" id="apellido1" placeholder="Primer Apellido" value="{{encargadoRecionalModel.apellidoPaterno}}" [(ngModel)]="encargadoRecionalModel.apellidoPaterno">
                    <div class="invalid" *ngIf="validacionApellido1" > Debe ingresar un Apellido valido</div>
                </div>
            </div>
            <div class="row row-form">
                <div class="col-sm-6">
                    <label>Segundo Apellido</label>
                </div>
                <div class="col-sm-6">
                    <input type="text" class="form-control" id="apellido2" placeholder="Segundo Apellido" value="{{encargadoRecionalModel.apellidoMaterno}}" [(ngModel)]="encargadoRecionalModel.apellidoMaterno">
                    <div class="invalid" *ngIf="validacionApellido2" > Debe ingresar un Apellido valido </div>
                </div>
            </div>
            <div class="row row-form">
                <div class="col-sm-6">
                    <label>Correo</label>
                </div>
                <div class="col-sm-6">
                    <input type="email" class="form-control" id="correo" placeholder="Correo" value="{{encargadoRecionalModel.email}}" [(ngModel)]="encargadoRecionalModel.email">
                    <div class="invalid" *ngIf="validacionEmail" > Debe ingresar un Correo valido</div>
                </div>
            </div>

            <div class="row row-form">
              <div class="col-sm-6">
                  <label>Usuario</label>
              </div>
              <div class="col-sm-6">
                  <input type="email" class="form-control" id="usuario" placeholder="Usuario" value="{{encargadoRecionalModel.usuario}}" [(ngModel)]="encargadoRecionalModel.usuario" disabled>
              </div>
          </div>

          <div class="row row-form">
            <div class="col-sm-6">
                <label>Contraseña</label>
            </div>
            <div class="col-sm-6">
                <input type="email" class="form-control" id="contrasena" placeholder="Contraseña" value="{{encargadoRecionalModel.contrasena}}" [(ngModel)]="encargadoRecionalModel.contrasena" disabled>
            </div>
        </div>

            <div class="row row-form mb-3">
              <div class="col-sm-6">
                  <label>Región</label>
              </div>
              <div class="col-sm-6">
                <select class="cerv" id="selectRegion" name="selectRegion" ngDefaultControl [(ngModel)]="encargadoRecionalModel.region.idRegion"  required>
                  <option [value]="-1" [selected]="encargadoRecionalModel?.region?.idRegion == -1" disabled>Seleccione una Región</option>
                  <option [value]="region.idRegion" *ngFor="let region of infoSelectJardin.regiones">{{region.nombre}}</option>
                </select>
                <div class="invalid" *ngIf="validacionRegion" > Debe Seleccionar una Región</div>
              </div>
          </div>
           
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-send mb-4" (click)="guardar()" style="background-color: #597CEE; height: 38px;color: #FFFFFF;"> Guardar</button>
    </div>
</ng-template>

  <ngx-spinner></ngx-spinner>